import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { VirtualOfficeCard } from './VirtualOfficeCard';

const Box = styled.div<{ columns: number }>`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  gap: 20px;

  @media (max-width: 800px) {
    display: flex;
    flex-direction: column;
  }
`;

interface VirtualOfficeGridProps {
  setSelected: Dispatch<SetStateAction<any>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setStep: Dispatch<SetStateAction<number>>;
  licences: any;
  showBuilderOffer?: boolean;
}

export const VirtualOfficeGrid = ({
  setSelected,
  setIsOpen,
  setStep,
  licences,
  showBuilderOffer = false
}: VirtualOfficeGridProps) => {
  const plans = showBuilderOffer
    ? licences
    : licences?.filter((plan: any) => !plan.isBuilderOffer);

  return (
    <Box columns={plans?.length || 1}>
      {plans?.map((plan: any, i: number) => (
        <VirtualOfficeCard
          key={i}
          plan={plan}
          setSelected={setSelected}
          setIsOpen={setIsOpen}
          setStep={setStep}
        />
      ))}
    </Box>
  );
};
